import { render, staticRenderFns } from "./LogoModal.vue?vue&type=template&id=66b908b8&scoped=true"
import script from "./LogoModal.vue?vue&type=script&lang=js"
export * from "./LogoModal.vue?vue&type=script&lang=js"
import style0 from "./LogoModal.vue?vue&type=style&index=0&id=66b908b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b908b8",
  null
  
)

export default component.exports